<div class="notitifcation-container">
    <div class="top-section-container">
        <div class="top-section container">
            <div class="title-container">
                <mat-icon svgIcon="arrowleft" class="left-arrow-icon" (click)="goBack()"></mat-icon>
                <span class="title font-poppins">Notifications</span>
            </div>
            <span class="subtitle">Updates about your orders, reviews, and more</span>
        </div>
    </div>

    <div class="body-container">
        @if (loading) {
            <mat-spinner class="loading-spinner" [diameter]="50"></mat-spinner>
        } @else if (!loading && notifications.length) {
            <div class="notifications-container">
                <div class="notification-content container">
                    <div class="items-count">
                      <div class="items-selected-container font-poppins">
                        <mat-checkbox
                          [checked]="isAllSelected()"
                          [indeterminate]="isSomeSelected()"
                          (change)="toggleSelectAll($event)"
                        >
                        </mat-checkbox>
                        <span
                          >{{selectedNotifications.size}}/{{ notifications.length }} Items
                          Selected</span
                        >
                      </div>
            
                      <div class="remove-move-container">
                        <button
                        [disabled]="selectedNotifications.size === 0"
                        mat-flat-button
                        class="remove-btn btn-secondary-gradient"
                        (click)="deleteSelectedNotifications()"
                        >
                            <mat-icon class="remove-icon">delete</mat-icon>
                            Remove
                        </button>
                      </div>
                    </div>
        
                    <div class="items-container">
                        @for (notification of notifications; track $index) {
                            <div class="item" [ngClass]="{'notification-unviewed': !notification.isMessageViewed, 'notification-viewed': notification.isMessageViewed}">
        
                                <div class="checkbox-info-container">
                                    <mat-checkbox
                                        class="notification-checkbox"
                                        (change)="toggleSelectNotification(notification.id)"
                                        [checked]="selectedNotifications.has(notification.id)"
                                    ></mat-checkbox>
            
                                    <div class="info">
                                        <div class="icon-title-container">
                                            <span class="icon-container">
                                                @if (notification.isMessageViewed) {
                                                    <mat-icon>drafts</mat-icon>
                                                } @else {
                                                    <mat-icon>markunread</mat-icon>
                                                }
                                            </span>
        
                                            <span class="title font-poppins">{{ notification.message }}</span>
                                        </div>
        
                                        <span class="time">
                                            <mat-icon class="time-icon">schedule</mat-icon>
                                            <span>{{ notification.createdAt | relativeTime }}</span>
                                        </span>
        
                                    </div>
                                </div>
        
                                <div class="actions">
                                    <mat-icon class="delete-icon" (click)="deleteNotification(notification.id)">
                                        delete
                                    </mat-icon>
        
                                    <span class="know-more-action" *ngIf="notification.type === mail.Mail" (click)="openMailPopup(notification); markNotificationAsViewed(notification.id)">
                                        Know More
                                        <mat-icon svgIcon="rightarrow" class="arrow-icon"></mat-icon>
                                    </span>
                                </div>
                            </div>
                        }
                    </div>
        
                    <div class="action-container" *ngIf="showViewMoreButton()">
                        <button mat-flat-button class="view-more-btn btn-primary-gradient" (click)="loadMoreNotifications()">
                            {{ "notification.button.viewMoreBtn" | translate }}
                        </button>
                    </div>
                </div>
    
            </div>
        } @else if(!loading && !notifications.length) {
            <div class="no-notifications" *ngIf="!loading">
                <mat-icon
                    svgIcon="emptyNotification"
                    class="emptyNotificationIcon"
                    aria-hidden="false"
                    aria-label="Empty Notification"
                />
                <h2>{{ "notification.heading.emptyNotification" | translate }}</h2>
                <p>{{ "notification.message.notificationMessage" | translate }}</p>
                <button mat-flat-button class="save-btn" (click)="goToHomePage()">
                    {{ "notification.button.backToHomeBtn" | translate }}
                </button>
            </div>
        }
    </div>
</div>
